import Topnavbar from "../../../Layouts/Topnavbar"
import { Container, Grid, Paper, Text, Title, ThemeIcon, Group, ActionIcon, Select, TextInput, Textarea, Button, Drawer, Badge, PinInput, Modal, Stack } from "@mantine/core";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    // Select,
    Input,
    // Button,
    Space,
    Card,
    Dropdown, message, Divider, Descriptions
} from "antd";
import { useEffect, useState } from "react";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { useWallet } from "../../../Context/Walletcontext";
import { Get_All_Users, get_revert_history, Revert_Fund } from "../../../apicall";
import dayjs from "dayjs";

const { Search } = Input;
const { RangePicker } = DatePicker;












const Revertrequest = ({ Headername }) => {
    const columns = [
        {
            title: "S.No",
            key: "sno",
            width: 70,
            render: (_, __, index) => index + 1,
        },
        {
            title: "Revert ID",
            dataIndex: "RevertId",
            width: 150,
        },
        {
            title: "User",
            dataIndex: ["toDetails", "username"],
            width: 120,
        },
        {
            title: "User Code",
            dataIndex: ["toDetails", "usercode"],
            width: 120,
        },
        {
            title: "Amount",
            dataIndex: "amount",
            align: "right",
            width: 120,
            render: (amount) => (
                <span style={{ fontWeight: 600 }}>
                    ₹ {amount.toLocaleString()}
                </span>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            width: 120,
            render: (status) => {
                let color = "default";

                if (status === "SUCCESS") color = "green";
                if (status === "PENDING") color = "orange";
                if (status === "FAILED") color = "red";

                return <Tag color={color}>{status}</Tag>;
            },
        },
        {
            title: "Date",
            dataIndex: "revertDate",
            width: 180,
            render: (date) =>
                dayjs(date).format("DD MMM YYYY, hh:mm A"),
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Space>
                    <Button
                        // type="link"
                        variant="outline"
                        size="xs"
                        onClick={() => {
                            setSelectedTransfer(record);
                            setTransferDrawer(true);
                        }}
                    >
                        View
                    </Button>
                </Space>
            ),
        },
    ];
    const { user } = Userauthcontexthooks();
    const { refreshWallet } = useWallet();
    const [userfindloading, setUserloading] = useState(false);
    const [mappedUsers, setMappedUsers] = useState({
        retailerLists: [],
        distributorsLists: [],
        masterDistributorLists: []
    });
    const [transferForm, setTransferForm] = useState({
        userType: "",
        selectedUser: null,
        amount: "",
        remarks: "",
    });
    const [mpin, setMpin] = useState("");
    const [transferLoading, setTransferLoading] = useState(false);
    const [mpinModal, setMpinModal] = useState(false);

    const [historyLoading, setHistoryLoading] = useState(true);
    const [fundTransferHistory, setFundTransferHistory] = useState([]);
    const [filteredFundTransferHistory, setFilteredFundTransferHistory] = useState([]);
    const [transferDrawer, setTransferDrawer] = useState(false);
    const [selectedTransfer, setSelectedTransfer] = useState(null);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("ALL");

    const handleSearch = () => {

        let filtered = [...fundTransferHistory];

        // Status Filter
        if (status !== "ALL") {
            filtered = filtered.filter(
                item => item.status === status
            );
        }

        // Transfer ID / User Code Search
        if (search.trim()) {

            const keyword = search.trim().toLowerCase();

            filtered = filtered.filter(item =>
                item.RevertId?.toLowerCase().includes(keyword) ||
                item.toDetails?.usercode?.toLowerCase().includes(keyword)
            );
        }

        setFilteredFundTransferHistory(filtered);
    };

    const handleReset = () => {
        setSearch("");
        setStatus("ALL");
        setFilteredFundTransferHistory(fundTransferHistory);
    };

    const handleTransferInput = (field, value) => {
        setTransferForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleUserTypeChange = async (value) => {
        setTransferForm((prev) => ({
            ...prev,
            userType: value,
            selectedUser: null,
        }));
        try {
            setUserloading(true);
            const data = await Get_All_Users();
            if (data.success) {
                //console.log(data);
                setMappedUsers({
                    retailerLists: data?.retailerLists,
                    distributorsLists: data?.distributorsLists,
                    masterDistributorLists: data?.masterDistributorLists,
                })
                //setWalletTransferHistory(data.transferHistory);
                //setFilteredWalletTransferHistory(data.transferHistory);
            }

        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setUserloading(false);
        }
    };

    const fetchFundTransferHistory = async () => {
        try {
            const data = await get_revert_history();
            if (data.success) {
                //console.log(data);
                setFundTransferHistory(data?.revertHistory);
                setFilteredFundTransferHistory(data?.revertHistory);
                //setTransferHistory(data?.transferHistory);
            }

        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setHistoryLoading(false);
        }
    }

    const retailerOptions = mappedUsers?.retailerLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const distributorOptions = mappedUsers?.distributorsLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const masterDistributorOptions = mappedUsers?.masterDistributorLists?.map((item) => ({
        value: item._id,
        label: `${item.userName} (${item.userCode})`,
    })) || [];

    const selectedUser = transferForm?.userType === "Retailer"
        ? mappedUsers?.retailerLists?.find(
            (x) => x?._id === transferForm?.selectedUser
        )
        : transferForm?.userType === "Distributor" ? mappedUsers?.distributorsLists?.find(
            (x) => x?._id === transferForm?.selectedUser
        ) : mappedUsers?.masterDistributorLists?.find(
            (x) => x?._id === transferForm?.selectedUser)

    const handleTransferSubmit = () => {
        if (!transferForm.userType) {
            return message.error("Please select user type.");
        }

        if (!transferForm.selectedUser) {
            return message.error("Please select a user.");
        }

        if (
            !transferForm.amount ||
            Number(transferForm.amount) <= 0
        ) {
            return message.error("Enter a valid revert amount.");
        }
        // Open MPIN modal here
        // call the mpin modal
        setMpinModal(true);
    };

    const confirmTransfer = async () => {
        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }
        const revertDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const selectedUser =
            transferForm?.userType === "Retailer"
                ? mappedUsers?.retailerLists?.find(
                    (x) => x?._id === transferForm?.selectedUser
                )
                : transferForm?.userType === "Distributor" ? mappedUsers?.distributorsLists?.find(
                    (x) => x?._id === transferForm?.selectedUser
                ) : mappedUsers?.masterDistributorLists?.find(
                    (x) => x?._id === transferForm?.selectedUser)

        const body = {
            revertDate,
            revertamount: transferForm.amount,
            remarks: transferForm.remarks,
            usercode: selectedUser.userCode,
            userid: selectedUser._id,
            usertype: selectedUser.acc_type,
            mpin
        }
        // console.log(body);
        try {
            setTransferLoading(true);
            // API CALL HERE
            const data = await Revert_Fund(body);
            if (data.success) {
                message.success(data.message);
                setMpinModal(false);
                setTransferForm({
                    amount: '',
                    remarks: '',
                    userType: '',
                    selectedUser: null
                })
                setMpin('');
                // setDistributordetails('');
                await refreshWallet(); // update the wallet in real time. 
                fetchFundTransferHistory();
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setTransferLoading(false);
        }

    };


    useEffect(() => {
        const fetchFundTransferHistory = async () => {
            try {
                const data = await get_revert_history();
                if (data.success) {
                    // console.log(data);
                    setFundTransferHistory(data?.revertHistory);
                    setFilteredFundTransferHistory(data?.revertHistory);
                    //setTransferHistory(data?.transferHistory);
                }

            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );

            } finally {
                setHistoryLoading(false);
            }
        }

        if (user) {
            fetchFundTransferHistory();
        }
    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'} >
                <Title c={'dimmed'}>Revert Requests</Title>
                <Text size="xs">Revert admin balance to users wallets.</Text>
            </Container >

            <Container size={'lg'} mt={'lg'} mb={'sm'}>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 12 }}>
                        <Paper shadow="sm" p={'xs'}>
                            <Select
                                label="Select User Type"
                                placeholder="Select User Type"
                                withAsterisk
                                mt="xs"
                                data={['Retailer', 'Distributor', 'Master Distributor']}
                                value={transferForm.userType}
                                onChange={handleUserTypeChange}
                                // loading={userprofileLoading}
                                style={{ width: "100%" }}
                            />
                            {transferForm.userType === "Retailer" && (
                                <Select
                                    label="Select Retailer"
                                    placeholder="Choose Retailer"
                                    searchable
                                    clearable
                                    nothingFoundMessage="No retailer found"
                                    withAsterisk
                                    mt="xs"
                                    data={retailerOptions}
                                    value={transferForm.selectedUser}
                                    onChange={(value) =>
                                        handleTransferInput("selectedUser", value)
                                    }
                                    comboboxProps={{
                                        withinPortal: false,
                                    }}
                                    loading={userfindloading}
                                />
                            )}
                            {transferForm.userType === "Distributor" && (
                                <Select
                                    label="Select Distributor"
                                    placeholder="Choose Distributor"
                                    searchable
                                    clearable
                                    nothingFoundMessage="No distributor found"
                                    withAsterisk
                                    mt="xs"
                                    data={distributorOptions}
                                    value={transferForm.selectedUser}
                                    onChange={(value) =>
                                        handleTransferInput("selectedUser", value)
                                    }
                                    comboboxProps={{
                                        withinPortal: false,
                                    }}
                                    loading={userfindloading}
                                />
                            )}
                            {transferForm.userType === "Master Distributor" && (
                                <Select
                                    label="Select Master Distributor"
                                    placeholder="Choose Master Distributor"
                                    searchable
                                    clearable
                                    nothingFoundMessage="No master distributor found"
                                    withAsterisk
                                    mt="xs"
                                    data={masterDistributorOptions}
                                    value={transferForm.selectedUser}
                                    onChange={(value) =>
                                        handleTransferInput("selectedUser", value)
                                    }
                                    comboboxProps={{
                                        withinPortal: false,
                                    }}
                                    loading={userfindloading}
                                />
                            )}
                            <TextInput
                                label="Revert Amount"
                                placeholder="0.00"
                                withAsterisk
                                mt="xs"
                                value={transferForm.amount}
                                onChange={(e) =>
                                    handleTransferInput("amount", e.target.value)
                                }
                            />
                            <Textarea
                                label="Remarks (Optional)"
                                placeholder="Write description here..."
                                mt="xs"
                                value={transferForm.remarks}
                                onChange={(e) =>
                                    handleTransferInput("remarks", e.target.value)
                                }
                            />
                            <Button
                                fullWidth
                                variant="light"
                                mt="md"
                                onClick={handleTransferSubmit}
                            >
                                Revert Amount
                            </Button>
                        </Paper>
                    </Grid.Col>

                    <Grid.Col span={{ xs: 12, sm: 12, md: 12 }}>
                        <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                            {/* <Col xs={24} md={8}>
                                    <RangePicker
                                        style={{ width: "100%" }}
                                        value={dateRange}
                                        onChange={(value) => setDateRange(value)}
                                        allowClear={false}
                                    />
                                </Col> */}
                            <Col xs={24} md={7}>
                                <Search
                                    placeholder="Search User Code or Revert ID"
                                    allowClear
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onSearch={handleSearch}
                                />
                            </Col>
                            <Col xs={24} md={4}>
                                <Select
                                    value={status}
                                    onChange={setStatus}
                                    style={{ width: "100%" }}
                                    data={[
                                        { label: "All Status", value: "ALL" },
                                        { label: "SUCCESS", value: "SUCCESS" },
                                        { label: "PENDING", value: "PENDING" },
                                        { label: "FAILED", value: "FAILED" },
                                    ]}
                                />
                            </Col>
                            <Col xs={24} md={6}>
                                <Space>
                                    <Button
                                        type="primary"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        variant="light"
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </Button>

                                    <Button
                                        variant="outline"
                                        onClick={fetchFundTransferHistory}
                                    >
                                        Refresh
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                        <Paper shadow="sm" p={'xs'}>
                            <Table
                                columns={columns}
                                dataSource={filteredFundTransferHistory}
                                rowKey="_id"
                                loading={historyLoading}
                                bordered
                                size="middle"
                                pagination={{
                                    pageSize: 10,
                                    showSizeChanger: true,
                                }} />
                        </Paper>
                    </Grid.Col>
                </Grid>
            </Container>

            <Modal
                opened={mpinModal}
                onClose={() => setMpinModal(false)}
                title="Confirm Revert"
                centered
                radius="md"
                size="md"
            >
                <Stack>

                    <Paper withBorder p="md" radius="md">

                        <Stack gap={8}>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    {transferForm?.userType}
                                </Text>

                                <Text fw={600}>
                                    {selectedUser?.userName}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    {transferForm?.userType} Code
                                </Text>

                                <Badge>
                                    {selectedUser?.userCode}
                                </Badge>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Mobile
                                </Text>

                                <Text>
                                    {selectedUser?.mobile}
                                </Text>
                            </Group>

                            <Divider />

                            <Group justify="space-between">
                                <Text size="sm" fw={600}>
                                    Revert Amount
                                </Text>

                                <Text
                                    fw={700}
                                    size="lg"
                                    c="green"
                                >
                                    ₹ {Number(transferForm.amount).toLocaleString()}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Remarks
                                </Text>

                                <Text>
                                    {transferForm.remarks || "-"}
                                </Text>
                            </Group>

                        </Stack>

                    </Paper>

                    <Divider />

                    <Stack align="center">

                        <Text fw={600}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setMpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        fullWidth
                        size="md"
                        loading={transferLoading}
                        // color="green"
                        onClick={confirmTransfer}
                    >
                        Confirm Revert ₹ {Number(transferForm.amount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>
            <Drawer
                title="Transfer Details"
                placement="right"
                width={500}
                opened={transferDrawer}
                onClose={() => setTransferDrawer(false)}
            >
                {selectedTransfer && (<>
                    <Descriptions
                        bordered
                        size="small"
                        column={1}
                    >
                        <Descriptions.Item label="Revert ID">
                            {selectedTransfer.RevertId}
                        </Descriptions.Item>

                        <Descriptions.Item label="Status">
                            <Tag
                                color={
                                    selectedTransfer.status === "SUCCESS"
                                        ? "green"
                                        : selectedTransfer.status === "FAILED"
                                            ? "red"
                                            : "orange"
                                }
                            >
                                {selectedTransfer.status}
                            </Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Revert Date">
                            {dayjs(selectedTransfer.revertDate).format(
                                "DD MMM YYYY, hh:mm:ss A"
                            )}
                        </Descriptions.Item>

                        <Descriptions.Item label="Revert Amount">
                            ₹ {selectedTransfer.amount.toLocaleString()}
                        </Descriptions.Item>
                        {/* <Descriptions.Item label="Outstanding Amount">
                            <Text strong c={'red'}>
                                ₹ {Number(selectedTransfer.outStandingamount).toFixed(2)}
                            </Text>
                        </Descriptions.Item> */}

                        {/* <Descriptions.Item label="Revert Status">
                            {selectedTransfer.outStandingamount <= 0 ? (
                                <Tag color="green">Settled</Tag>
                            ) : (
                                <Tag color="orange">Pending</Tag>
                            )}
                        </Descriptions.Item> */}

                        <Descriptions.Item label="Remarks">
                            {selectedTransfer.remarks || "-"}
                        </Descriptions.Item>

                        {/* <Divider /> */}

                        <Descriptions.Item label="User Name">
                            {selectedTransfer.toDetails?.username}
                        </Descriptions.Item>

                        <Descriptions.Item label="User Code">
                            {selectedTransfer.toDetails?.usercode}
                        </Descriptions.Item>

                        <Descriptions.Item label="User Mobile">
                            {selectedTransfer.toDetails?.mobile}
                        </Descriptions.Item>

                        <Descriptions.Item label="User Type">
                            {selectedTransfer.toDetails?.usertype}
                        </Descriptions.Item>


                    </Descriptions>
                    <Divider />

                    {/* <Row justify="end">
                        <Button
                            // type="primary"
                            variant="light"
                            mt={'xs'}
                            fullWidth
                            onClick={() => {
                                setRevertModal(true);
                                // setRevertAmount(selectedTransfer.outStandingamount);
                            }}
                            disabled={
                                selectedTransfer.isTransactionSquareof ||
                                selectedTransfer.outStandingamount <= 0
                            }
                        >
                            Take Revert
                        </Button>
                    </Row> */}
                </>
                )}
            </Drawer>
        </>
    )
}
export default Revertrequest